import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'redactedBankAccount'
})
export class RedactedBankAccountPipe implements PipeTransform {
    public transform(redactedBankAccount: any): string {
        let redactedBankAccountString = '';
        if (redactedBankAccount.bankName) {
            redactedBankAccountString += `${redactedBankAccount.bankName} `;
        }
        if (redactedBankAccount.redactedAccountNumber) {
            redactedBankAccountString += `${redactedBankAccount.redactedAccountNumber}`;
        }
        return redactedBankAccountString;
    }
}
